<template>
  <div class="HomeBox">
    <van-pull-refresh v-model="refresh" @refresh="onRefresh">
      <div class="errorContent" v-if="error">
        <div class="errorContent-text">{{ $t.alert.networkError }}</div>
        <van-button size="small" @click="getMenuInfoList(false)" v-if="UserId">{{
          $t.alert.reload
        }}</van-button>
        <van-button size="small" @click="loadCustomerHomeInfo(false)" v-if="CustomerId">{{
          $t.alert.reload
        }}</van-button>
      </div>
      <div class="homeContent" v-else>
        <banner :images="images" />
        <menu-list :menuData="menuData" :menuIndex="menuIndex" />
      </div>
    </van-pull-refresh>

    <van-dialog
      v-model="showUpdate"
      @confirm="updateConfirm"
      @cancel="updateCancel"
      :title="$t.meta.newVersion + ' ( ' + updateForm.VersionCode + ' ) '"
      :confirm-button-text="$t.meta.updateButton"
      :cancel-button-text="$t.meta.laterButton"
      :show-cancel-button="updateForm.UpdateType == 1 ? true : false"
      :before-close="
        (action, done) => {
          done(false);
        }
      "
      show-confirm-button
      theme="round-button"
      cancel-button-color="#f1f1f1"
      confirm-button-color="#1989fa"
      class="update-dialog"
    >
      <slot name="default">
        <div class="update-alert">
          <div class="v-text" v-html="updateForm.UpdateContent"></div>
        </div>
      </slot>
    </van-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import Banner from "./components/Banner";
import MenuList from "./components/MenuList";
import { isAPP, getPlatform } from "@/plugins/environment/type.js";
import { Swipe, SwipeItem, List, Icon, Popover, PullRefresh } from "vant";
import { getVersionNumber } from "@/plugins/environment/model/appVersion";
import { mapGetters, mapMutations } from "vuex";
import { SET_AUTH } from "@/store/mutation-types";

Vue.use(Swipe).use(SwipeItem).use(List).use(Icon).use(Popover);

export default {
  name: "home",
  components: {
    Banner,
    MenuList,
    "van-pull-refresh": PullRefresh,
  },
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CustomerId: JSON.parse(localStorage.getItem("auth")).userInfo.CustomerId,
      isApp: isAPP(),
      platform: getPlatform(),
      images: [],
      //菜单缓存
      menuData: [],
      menuIndex: {
        active1: 0,
        active2: 0,
      },
      refresh: false,
      error: false,
      //更新弹窗
      showUpdate: false,
      updateForm: {},
      curVersion: "9.9.9",
      storageKey: "updateForm",
      //更多
      showPopover: false,
      actions: [],
      moreIcon: require("@/assets/img/home/more.png"),
    };
  },
  computed: {
    ...mapGetters(["isLogging"]),
  },
  mounted() {
    //极光推送
    if (this.UserId) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.setAlias, {
        alias: this.UserId,
      });
      if (this.isLogging) {
        this.getMenuInfoList(false);
      }
    }
    if (this.CustomerId) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.setAlias, {
        alias: this.CustomerId,
      });
      if (this.isLogging) {
        this.loadCustomerHomeInfo(false);
      }
    }
    //记录主页菜单
    var menuIndex = JSON.parse(localStorage.getItem("MenuList"));
    if (menuIndex) {
      this.menuIndex = menuIndex;
    } else {
      this.menuIndex = {
        active1: 0,
        active2: 0,
      };
    }
    //记录页面菜单
    localStorage.setItem("MenuState", "1");
    //检测更新
    this.checkUpdate();
  },
  methods: {
    checkUpdate() {
      var storageForm = JSON.parse(localStorage.getItem(this.storageKey));
      var onShowUpdate = () => {
        if (this.curVersion < this.updateForm.VersionCode) {
          if (storageForm) {
            //又有新版本（比如1.0.2）
            if (storageForm.VersionCode < this.updateForm.VersionCode) {
              this.showUpdate = true;
            }
            //点了明天更新，明天到了提醒
            if (storageForm.UpdateTime <= this.getToday(false)) {
              this.showUpdate = true;
            }
          } else {
            //有新版本（比如1.0.1）
            this.showUpdate = true;
            localStorage.setItem(this.storageKey, null);
          }
        }
      };
      this.getVersionInfoByPlatform().then((success) => {
        if (success) {
          if (this.isApp) {
            getVersionNumber().then((version) => {
              this.curVersion = version;
              onShowUpdate();
            });
          } else {
            onShowUpdate();
          }
        }
      });
    },
    getVersionInfoByPlatform() {
      return new Promise((resolve) => {
        let param = {
          Platform: this.platform == "ios" ? 1 : 2,
        };
        this.$api.myHome.getVersionInfoByPlatform(param).then((res) => {
          if (res.data) {
            this.updateForm = res.data;
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    updateConfirm() {
      var url = "";
      if (this.platform == "android") {
        url = "https://a.app.qq.com/o/simple.jsp?pkgname=com.vtrack.app";
      }
      if (this.platform == "ios") {
        url = "https://apps.apple.com/app/vtrack/id6745947971";
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.gotoPay, {
        url: url,
      });
    },
    updateCancel() {
      localStorage.setItem(
        this.storageKey,
        JSON.stringify({
          VersionCode: this.updateForm.VersionCode,
          UpdateTime: this.getToday(true),
        })
      );
      this.showUpdate = false;
    },
    onRefresh() {
      this.refresh = true;
      var request = null;
      if (this.UserId) {
        request = this.getMenuInfoList(true);
      }
      if (this.CustomerId) {
        request = this.loadCustomerHomeInfo(true);
      }
      request
        .then(() => {
          this.refresh = false;
        })
        .catch(() => {
          this.refresh = false;
        });
    },
    getMenuInfoList(hideLoading = false) {
      return new Promise((resolve, reject) => {
        if (!hideLoading) {
          this.$commonMethod.showLoading();
        }
        let param = {
          IsWeChatShowNav: 1, //app菜单
        };
        this.$api.user
          .getMenuInfoList(param)
          .then((res) => {
            this.menuData = res.data;
            this.getUserInfo();
            if (!hideLoading) {
              this.$commonMethod.hideLoading();
            }
            this.error = false;
            resolve(true);
          })
          .catch((error) => {
            if (!hideLoading) {
              this.$commonMethod.hideLoading();
            }
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            this.error = true;
            reject(true);
          });
      });
    },
    getToday(isTomorrow) {
      var time = new Date().toLocaleDateString();
      let [year, month, day] = time.split("/");
      if (isTomorrow) {
        day = parseInt(day) + 1;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day;
    },
    getUserInfo() {
      var param = {
        UserId: this.UserId,
      };
      this.$api.myHome
        .getUserInfo(param)
        .then((res) => {
          this.SET_AUTH(res.data);
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    loadCustomerHomeInfo(hideLoading = false) {
      return new Promise((resolve, reject) => {
        if (!hideLoading) {
          this.$commonMethod.showLoading();
        }
        let param = {
          CustomerId: this.CustomerId,
        };
        this.$api.customerManagement
          .loadCustomerHomeInfo(param)
          .then((res) => {
            this.images = res.data.AdvertList || [];
            this.getMyCustomerMenuList();
            if (!hideLoading) {
              this.$commonMethod.hideLoading();
            }
            this.SET_AUTH(res.data);
            this.error = false;
            resolve(true);
          })
          .catch((error) => {
            if (!hideLoading) {
              this.$commonMethod.hideLoading();
            }
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            this.error = true;
            reject(true);
          });
      });
    },
    getMyCustomerMenuList() {
      this.menuData = [
        {
          MenuName: this.$t.router.customerHome,
          MenuUrl: "/customerHome",
          Icon: "el-icon-user",
          ChildList: [
            {
              MenuName: this.$t.router.customerInfo,
              MenuUrl: "customerInfo",
              Component: "myCustomer/customerInfo",
              ChildList: [],
            },
          ],
        },
        {
          MenuName: this.$t.router.logisticsSection,
          MenuUrl: "/logisticsSection",
          Icon: "el-icon-direction",
          ChildList: [
            {
              MenuName: this.$t.router.freightInquiry,
              MenuUrl: "freightInquiry",
              Component: "myCustomer/freightInquiry",
              ChildList: [],
            },
            {
              MenuName: this.$t.router.shippingAddress,
              MenuUrl: "shippingAddress",
              Component: "myCustomer/shippingAddress",
              ChildList: [],
            },
            {
              MenuName: this.$t.router.myWallet,
              MenuUrl: "myWallet",
              Component: "myCustomer/myWallet",
              ChildList: [],
            },
            {
              MenuName: this.$t.router.orderManagement,
              MenuUrl: "orderManagement",
              Component: "myCustomer/orderManagement",
              ChildList: [],
            },
          ],
        },
        {
          MenuName: this.$t.router.entrustOrder,
          MenuUrl: "/entrustOrder",
          Icon: "el-icon-s-order",
          ChildList: [
            {
              MenuName: this.$t.router.entrustOrderList,
              MenuUrl: "entrustOrder",
              Component: "myCustomer/entrustOrder",
              ChildList: [],
            },
          ],
        },
        {
          MenuName: this.$t.router.freightOrder,
          MenuUrl: "/freightOrder",
          Icon: "el-icon-search",
          ChildList: [
            {
              MenuName: this.$t.router.freightOrderList,
              MenuUrl: "freightOrder",
              Component: "myCustomer/freightOrder",
              ChildList: [],
            },
          ],
        },
        {
          MenuName: this.$t.router.financialCounting,
          MenuUrl: "/debtList",
          Icon: "el-icon-money",
          ChildList: [
            {
              MenuName: this.$t.router.debtList,
              MenuUrl: "debtList",
              Component: "myCustomer/debtList",
              ChildList: [],
            },
          ],
        },
        {
          MenuName: this.$t.router.warehouseManagement,
          MenuUrl: "/warehouseManagement",
          Icon: "el-icon-house",
          ChildList: [
            {
              MenuName: this.$t.router.warehouseQuery,
              MenuUrl: "warehouseQuery",
              Component: "myCustomer/warehouseQuery",
              ChildList: [],
            },
            {
              MenuName: this.$t.router.warehouseStatement,
              MenuUrl: "warehouseStatement",
              Component: "myCustomer/warehouseStatement",
              ChildList: [],
            },
          ],
        },
      ];
    },
    ...mapMutations([SET_AUTH]),
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";

.HomeBox {
  $-headerhight: 50px;

  .van-pull-refresh {
    overflow: unset;
  }

  .homeContent {
    display: inline-block;
    width: 100%;
  }

  .errorContent {
    padding-top: $-headerhight * 2;
    text-align: center;
    height: 120vh;

    .errorContent-text {
      font-size: 14px;
      color: #969799;
      margin-bottom: $-headerhight;
    }

    .van-button {
      .van-button__text {
        font-size: 14px !important;
      }
    }
  }

  .update-dialog {
    ::v-deep .van-dialog__cancel {
      .van-button__text {
        color: #999;
        font-weight: normal;
        font-size: 14px !important;
      }
    }

    ::v-deep .van-dialog__confirm {
      .van-button__text {
        color: #fff;
        font-weight: normal;
        font-size: 14px !important;
      }
    }

    .update-alert {
      padding: 5% 8% 3% 8%;
      font-size: 14px;
      line-height: 2;

      .v-text {
        max-height: 400px;
      }
    }
  }
}
</style>
